import { Col, Row, Table } from "reactstrap"
import { useEffect, useState } from "react";
import { AddModal, ConfirmationModal, InfoModal } from "./BaseModal";
import { addContact, deleteContact, getContacts, updateContact } from "../api/api";
import Spinner from "./Spinner";

const Setting = () => {


    const [modal, setModal] = useState(false);
    const [newUser, setNewUser] = useState(false);
    const [openInfo, setOpenInfo] = useState(false);
    const authToken = localStorage.getItem('accessToken');
    const groupId = localStorage.getItem('username');
    const [contact, setContact] = useState();
    const [msg, setMsg] = useState();
    const [loading, setLoading] = useState(false);
    const [email, setEmail] = useState('');
    const [username, setUsername] = useState('');
    const [id, setId] = useState(null);
    const [confirm, setConfirm] = useState(false);
    const [title, setTitle] = useState({ title: "", message: "", button: "", task: "" })
    const [emailChanged, setEmailChanged] = useState(false);
    const [confirmDisable, setConfirmDisable] = useState(false);
    const [prevVal, setPrevVal] = useState('');
    const toggleModal = () => {
        setModal(!modal);
        setMsg();
        setEmail('');
        setUsername('');
        setEmailChanged(false);
    }
    const toggleNewUser = () => {
        setNewUser(!newUser);
        setMsg();
        setEmail('');
        setUsername('');
    };
    const toggleOpenInfo = () => {
        if (msg.includes("失敗")) {
            window.location.reload();
        }
        setOpenInfo(!openInfo);
        setMsg();
        setEmail('');
        setUsername('');
        setPrevVal('');
    };

    const toggleConfirm = () => {
        setConfirm(!confirm);
        setMsg();
        if (title.task === 'add') {
            setNewUser(true);
        }
        else if (title.task === 'update') {
            setModal(true);
        }
        else {
            setEmail('');
            setUsername('');
        }
    }

    useEffect(() => {
        setLoading(true);
        const controller = new AbortController();
        const signal = controller.signal;
        fetchData(signal);

        return () => {
            controller.abort();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])



    const fetchData = async (signal) => {
        const data = await getContacts(authToken, groupId, signal);
        setContact(data);
        setLoading(false);
    }

    const handleAddNewUser = () => {
        if (contact.contact_user.length !== contact.limit_registration) {
            setNewUser(!newUser);
        } else {
            setOpenInfo(!openInfo);
            setMsg(`登録数は${contact.limit_registration}つまでです。`)
        }
    }

    const validate = (e) => {
        const email = e;
        // setEmail(email);

        // Email validation regex
        const regex = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)+$/;
        // double byte regex
        // eslint-disable-next-line no-control-regex
        const regex1 = /[^\u0000-\u00ff]/;

        if (!regex1.test(email)) {
            if (!regex.test(email)) {
                setMsg('Eメールアドレスに誤りがあります。');
                return false;
            } else {
                if (contact.contact_user.some(user => user.email === email)) {
                    setMsg('既に登録されているメールアドレスです。');
                    return false;
                } else {
                    setMsg('');
                    return true;
                }
            }
        } else {
            setMsg('全角文字は使用できません。');
        }
    }

    const handleAddUser = async () => {
        const isValid = validate(email);
        if (isValid) {
            if (username !== '') {
                setNewUser(!newUser);
                setConfirm(!confirm);
                setTitle({
                    title: "確認画面",
                    message: "追加するユーザー情報を確認ください。",
                    button: "追加",
                    task: 'add'

                });
            } else {
                setMsg("ユーザー名を入力してください。")
            }
        }
    }

    const handleEdit = (e, index) => {
        setEmail(contact.contact_user[index].email)
        setPrevVal(contact.contact_user[index].email)
        setUsername(contact.contact_user[index].user_name);
        setModal(true);
        setId(contact.contact_user[index].contact_id);
    }

    const handleUpdateUser = async () => {
        if (emailChanged) {
            const isValid = email === prevVal ? true : validate(email);
            if (isValid) {
                if (username !== '') {
                    setModal(!modal);
                    setConfirm(!confirm);
                    setTitle({
                        title: "確認画面",
                        message: "更新内容を確認ください。",
                        button: "更新",
                        task: 'update'
                    });
                    setEmailChanged(false);
                } else {
                    setMsg("ユーザー名を入力してください。")
                }
            }
        } else {
            if (username !== '') {
                setModal(!modal);
                setConfirm(!confirm);
                setTitle({
                    title: "確認画面",
                    message: "更新内容を確認ください。",
                    button: "確認",
                    task: 'update'
                });
                setEmailChanged(false);
            } else {
                setMsg("ユーザー名を入力してください。")
            }
        }
    }

    const handleDeleteUser = async (e, index) => {
        setEmail(contact.contact_user[index].email)
        setUsername(contact.contact_user[index].user_name);
        setConfirm(!confirm);
        setTitle({
            title: "確認画面",
            message: "以下のユーザー情報を本当に削除しますか？",
            button: "削除",
            task: "delete"
        });
        setId(contact.contact_user[index].contact_id);
    }

    const handleInput = async () => {
        setConfirmDisable(true)
        if (title.task === "add") {
            const data = await addContact(authToken, groupId, email, username);
            if (data === true) {
                setConfirm(!confirm);
                setMsg("ユーザー情報を追加しました。");
                setOpenInfo(!openInfo);
                fetchData();
            } else {
                setConfirm(!confirm);
                setMsg("ユーザー情報の追加に失敗しました。");
                setOpenInfo(!openInfo);
                // window.location.reload();
            }
        }
        if (title.task === "update") {
            const data = await updateContact(authToken, groupId, email, username, id);
            if (data === true) {
                setConfirm(!confirm);
                setMsg("ユーザー情報を更新しました。");
                setOpenInfo(!openInfo);
                fetchData();
            } else {
                setConfirm(!confirm);
                setMsg("ユーザー情報の更新に失敗しました。");
                setOpenInfo(!openInfo);
                // window.location.reload();
            }
        }
        if (title.task === "delete") {
            const data = await deleteContact(authToken, groupId, email, username, id);
            if (data === true) {
                setConfirm(!confirm);
                setMsg("ユーザー情報を削除しました。");
                setOpenInfo(!openInfo);
                fetchData();
            } else {
                setConfirm(!confirm);
                setMsg("ユーザー情報の削除に失敗しました。");
                setOpenInfo(!openInfo);
                // window.location.reload();
            }
        }
        setEmail('');
        setUsername('');
        setConfirmDisable(false);
    }

    if (loading) {
        return <Spinner />
    }

    return (
        <Col className="px-5">
            <AddModal
                title={"ユーザーの編集"}
                open={modal}
                btnLeft="閉じる"
                btnRight="確認"
                content={
                    <>
                        <div className="form-wrapper-setting d-flex justify-content-between">

                            <div className='full-input-setting'><label for='name'>Eメール</label>
                                <input type="text" id="email" value={email} onChange={(e) => { setEmail(e.target.value); setEmailChanged(true) }} />
                            </div>
                            <div className='full-input-setting'><label for='email'>ユーザー名</label>
                                <input type="text" value={username} onChange={(e) => { setUsername(e.target.value) }} /></div>
                        </div>
                        <p className="text-danger mt-3 modalContent">{msg}</p>
                    </>
                }
                handleLeft={toggleModal}
                handleRight={handleUpdateUser}
                handleOpen={toggleModal}

            />
            <AddModal
                title={"ユーザーの追加"}
                open={newUser}
                btnLeft="閉じる"
                btnRight="確認"
                content={
                    <>
                        <div className="form-wrapper-setting d-flex justify-content-between">

                            <div className='full-input-setting'><label for='name'>Eメール</label>
                                <input type="text" id="email" value={email} onChange={(e) => { setEmail(e.target.value) }} />
                            </div>
                            <div className='full-input-setting'><label for='email'>ユーザー名</label>
                                <input type="text" value={username} onChange={(e) => { setUsername(e.target.value) }} /></div>

                        </div>
                        <p className="text-danger mt-3 modalContent">{msg}</p>
                    </>
                }
                handleLeft={toggleNewUser}
                handleRight={handleAddUser}
                handleOpen={toggleNewUser}

            />
            <InfoModal
                open={openInfo}
                button="OK"
                content={msg}
                handleButton={toggleOpenInfo}
            />

            <ConfirmationModal title={title.title}
                open={confirm}
                btnLeft="キャンセル"
                btnRight={title.button}
                content={
                    <>
                        <p>{title.message}</p>
                        <div className="pl-3 info-box">
                            <p>
                                ユーザー名：{username}
                            </p>
                            <p>Eメール　 ：{email}</p>
                        </div>
                    </>
                }
                handleLeft={toggleConfirm}
                handleRight={handleInput}
                handleOpen={toggleNewUser}
                status={confirmDisable}
            />
            <Row className="text_graph justify-content-center mt-2">
                ユーザー設定
            </Row>
            <Row className="settingsTable">
                <div className="setting mx-2">
                    <span>ここでは、発電所で障害が発生した際に通知するユーザーを登録できます。</span><br />
                    <span>新規ユーザーの登録、変更、削除が行えます</span>
                </div>
            </Row>
            <Row>
                <Table className="table_setting table-responsive mx-2">
                    <thead>
                        <tr>
                            <th className="tableheader1">番号</th>
                            <th>ユーザー名</th>
                            <th>Eメール</th>
                            <th className="tableheader2">
                                <div className="setting_header">
                                    <div className="setting_header1">追加</div>
                                    <div className="setting-header2">
                                        <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" className="ml-2" onClick={() => handleAddNewUser()} style={{ cursor: "pointer" }}>
                                            <rect width="32" height="32" fill="#233C6B" />
                                            <line x1="6" y1="16" x2="26" y2="16" stroke="white" stroke-width="2" />
                                            <line x1="16" y1="26" x2="16" y2="6" stroke="white" stroke-width="2" />
                                        </svg>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </thead>
                    {contact && contact.contact_user.map((value, index) => {
                        return (
                            <tr key={index}>
                                <td>{index + 1}.</td>
                                <td>{value.user_name}</td>
                                <td>
                                    <div className="email-icons">
                                        <div className="email-box">
                                            {value.email}
                                        </div>

                                        <div className="action-icons">
                                            <svg width="15" height="25" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(e) => { handleEdit(e, index) }} className="desktopIcons" style={{ cursor: "pointer" }}>
                                                <path fillRule="evenodd" clipRule="evenodd" d="M14.2038 7.79601L15.9998 6C16.545 5.45475 16.8176 5.18213 16.9634 4.88803C17.2407 4.32848 17.2407 3.67153 16.9634 3.11197C16.8176 2.81788 16.545 2.54525 15.9998 2C15.4545 1.45475 15.1819 1.18213 14.8878 1.03639C14.3282 0.75911 13.6713 0.75911 13.1117 1.03639C12.8176 1.18213 12.545 1.45475 11.9998 2L10.1811 3.81866C11.145 5.46926 12.5311 6.84482 14.2038 7.79601ZM8.72666 5.27312L1.85615 12.1436C1.43109 12.5687 1.21856 12.7812 1.07883 13.0423C0.939091 13.3034 0.880146 13.5981 0.762256 14.1876L0.14686 17.2646C0.0803376 17.5972 0.0470765 17.7635 0.141684 17.8581C0.236293 17.9527 0.402598 17.9194 0.735208 17.8529L3.81219 17.2375C4.40164 17.1196 4.69637 17.0607 4.95746 16.9209C5.21856 16.7812 5.43109 16.5687 5.85615 16.1436L12.7456 9.25422C11.1239 8.23857 9.7522 6.87628 8.72666 5.27312Z" fill="#233C6B" />
                                            </svg>
                                            <svg width="15" height="24" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(e) => { handleDeleteUser(e, index) }} className="trash-icon desktopIcons" style={{ cursor: "pointer" }}>
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M0 5C0 4.44772 0.447715 4 1 4H23C23.5523 4 24 4.44772 24 5C24 5.55228 23.5523 6 23 6H1C0.447715 6 0 5.55228 0 5Z" fill="#FF0000" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M6 1C6 0.447715 6.44772 0 7 0H17C17.5523 0 18 0.447715 18 1C18 1.55228 17.5523 2 17 2H7C6.44772 2 6 1.55228 6 1Z" fill="#FF0000" />
                                                <path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C3.55228 4 4 4.44772 4 5V24H20V5C20 4.44772 20.4477 4 21 4C21.5523 4 22 4.44772 22 5V24C22 24.5304 21.7893 25.0391 21.4142 25.4142C21.0391 25.7893 20.5304 26 20 26H4C3.46957 26 2.96086 25.7893 2.58579 25.4142C2.21071 25.0391 2 24.5304 2 24V5C2 4.44772 2.44772 4 3 4Z" fill="#FF0000" />
                                            </svg>

                                        </div>

                                    </div>


                                </td>
                                <td className="mobileIcons">
                                    <svg width="20" height="30" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(e) => { handleEdit(e, index) }} style={{ cursor: "pointer" }}>
                                        <path fillRule="evenodd" clipRule="evenodd" d="M14.2038 7.79601L15.9998 6C16.545 5.45475 16.8176 5.18213 16.9634 4.88803C17.2407 4.32848 17.2407 3.67153 16.9634 3.11197C16.8176 2.81788 16.545 2.54525 15.9998 2C15.4545 1.45475 15.1819 1.18213 14.8878 1.03639C14.3282 0.75911 13.6713 0.75911 13.1117 1.03639C12.8176 1.18213 12.545 1.45475 11.9998 2L10.1811 3.81866C11.145 5.46926 12.5311 6.84482 14.2038 7.79601ZM8.72666 5.27312L1.85615 12.1436C1.43109 12.5687 1.21856 12.7812 1.07883 13.0423C0.939091 13.3034 0.880146 13.5981 0.762256 14.1876L0.14686 17.2646C0.0803376 17.5972 0.0470765 17.7635 0.141684 17.8581C0.236293 17.9527 0.402598 17.9194 0.735208 17.8529L3.81219 17.2375C4.40164 17.1196 4.69637 17.0607 4.95746 16.9209C5.21856 16.7812 5.43109 16.5687 5.85615 16.1436L12.7456 9.25422C11.1239 8.23857 9.7522 6.87628 8.72666 5.27312Z" fill="#233C6B" />
                                    </svg>
                                    <svg width="22" height="24" viewBox="0 0 24 26" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={(e) => { handleDeleteUser(e, index) }} className="trash-icon" style={{ cursor: "pointer" }}>
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M0 5C0 4.44772 0.447715 4 1 4H23C23.5523 4 24 4.44772 24 5C24 5.55228 23.5523 6 23 6H1C0.447715 6 0 5.55228 0 5Z" fill="#FF0000" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M6 1C6 0.447715 6.44772 0 7 0H17C17.5523 0 18 0.447715 18 1C18 1.55228 17.5523 2 17 2H7C6.44772 2 6 1.55228 6 1Z" fill="#FF0000" />
                                        <path fill-rule="evenodd" clip-rule="evenodd" d="M3 4C3.55228 4 4 4.44772 4 5V24H20V5C20 4.44772 20.4477 4 21 4C21.5523 4 22 4.44772 22 5V24C22 24.5304 21.7893 25.0391 21.4142 25.4142C21.0391 25.7893 20.5304 26 20 26H4C3.46957 26 2.96086 25.7893 2.58579 25.4142C2.21071 25.0391 2 24.5304 2 24V5C2 4.44772 2.44772 4 3 4Z" fill="#FF0000" />
                                    </svg>

                                </td>
                            </tr>
                        )
                    })}
                </Table>
            </Row>
        </Col >
    )
}

export default Setting;